<template>
  <el-select
    class="select"
    v-model="houseName"
    filterable
    remote
    placeholder="请输入楼盘名"
    :remote-method="searchHouse"
    @change="checkHouseItem"
    clearable
    :loading="houseLoading"
  >
    <el-option
      v-for="item in houseOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    >
    </el-option>
  </el-select>
</template>

<script>
// houseList
import { houseDropList } from '@/api/houseApi.js';
import { getToken } from '@/utils/token.js';
export default {
  name: 'allotHouseSelect',
  data() {
    return {
      houseName: '',
      houseOptions: [],
      houseLoading: false,
    };
  },
  methods: {
    // 搜索用户
    async searchHouse(val) {
      try {
        const areaId = JSON.parse(getToken('areaId')).areaId;
        let res = await houseDropList({
          areaId,
          houseName: val,
          pageIndex: 1,
          pageSize: 999,
        });
        this.$nextTick(() => {
          this.houseOptions =
            res.data && res.data.dataList.length && res.data.dataList
              ? JSON.parse(
                  JSON.stringify(res.data.dataList)
                    .replace(/houseName/g, 'label')
                    .replace(/houseId/g, 'value')
                )
              : [];
        });
      } catch (e) {
        window.console.log(e);
      }
    },
    // 选择下拉选项
    checkHouseItem(val) {
      this.$emit('setHouseId', val);
    },
  },
};
</script>

<style></style>
